// Phase SIKA-5e/4 — SikaChatPage router shim.
//
// Dispatches between the new Claude.ai-style v2 page and the legacy
// 3-column workspace based on the SIKA_CHAT_V2 feature flag.
//
// Default for the flag: ON. Users can opt back to the legacy chat
// surface for 7 days via:
//   localStorage.setItem('strikza:sika:chat-v2', '0')
//
// This shim is removed in 5e/5 alongside the legacy file. Routes
// continue to import `SikaChatPage` from this module — no router
// edit required.

import { useSikaChatV2 } from "../../sika/featureFlags.ts";
import { SikaChatPageLegacy } from "./SikaChatPageLegacy.tsx";
import { SikaChatPageV2 } from "./SikaChatPage.v2.tsx";

export function SikaChatPage(): JSX.Element {
  const { enabled } = useSikaChatV2(true);
  return enabled ? <SikaChatPageV2 /> : <SikaChatPageLegacy />;
}
